import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface HamSegmentedToggleOption {
    value: string;
    /** Ready to show; nothing is translated here. */
    label: string;
}

/**
 * REV-22155 — switch between a few options, e.g. "Firmen / Personen" on the projects and the
 * configuration page. Look: prototype `Projekteübersicht-Personen.png` / `mandatsverwaltung neu.png`
 * (without the counts).
 *
 * Controlled: shows `selected` and reports a click on another option; the host decides.
 */
@Component({
    selector: 'ham-segmented-toggle',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<div class="ham-segmented-toggle" role="tablist">
        <button
            *ngFor="let option of options"
            type="button"
            role="tab"
            class="ham-segmented-toggle__option"
            [class.is-selected]="option.value === selected"
            [attr.aria-selected]="option.value === selected"
            [attr.data-testid]="optionTestIdPrefix + '-' + option.value.toLowerCase()"
            (click)="select(option.value)"
        >
            {{ option.label }}
        </button>
    </div>`,
    styleUrls: ['./ham-segmented-toggle.component.scss'],
})
export class HamSegmentedToggleComponent {
    @Input() options: HamSegmentedToggleOption[] = [];
    @Input() selected: string | null = null;
    /** `data-testid` of each option = `<prefix>-<value in lower case>` (e2e selector contracts). */
    @Input() optionTestIdPrefix = 'segmented-toggle';
    @Output() selectionChange = new EventEmitter<string>();

    select(value: string): void {
        if (value !== this.selected) {
            this.selectionChange.emit(value);
        }
    }
}
